// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {1869: "37804b41518f00be",8877: "94e8c2ceb60ec630",}[chunkId] + ".css"
}// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {1869: "37804b41518f00be",8877: "94e8c2ceb60ec630",}[chunkId] + ".css"
}